module.exports = __webpack_public_path__ + "static/media/09.57c30b95.jpg";